import { memo } from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

const wrappedComponent = memo(styled(Icon)``);
wrappedComponent.testable = Icon;

export default wrappedComponent;
